import { timestamps, uuid } from '@snap-types/models/common';
import { z } from 'zod/v4';

export const columns = {
  id: uuid,
  userId: z.string(),
  phoneNumber: z.string().nullable(),
  mobilePhoneNumber: z.string().nullable(),
  signatureTitle: z.string().nullable(),
  emailQuoteToCustomer: z.boolean().default(true),

  // visualUserName is a foreign key into Visual's USER table (QUOTE.USER_ID
  // nvarchar(20)). Enforced by Postgres itself (UserSettings.visualUserName's
  // @db.VarChar(20) in schema.prisma) - `.max()` here just gives a clean
  // rejection before that; assertVisualIdentifierFits (snap-quote-to-vis.ts)
  // still guards the other source of Quote.userId, a caller-supplied override
  // that isn't backed by any Postgres column.
  visualUserName: z.string().max(20).nullable(),

  ...timestamps,
};
